import React from "react";
import {connect} from "react-redux";
import Header from "../../common/components/Header";
import RecentDisclosure from "./RecentDisclosure";
import { getRecentDisclosures } from "../recordingReducers";
import {MAIN_SECTION} from "../../styles";

export const RecentDisclosures = (props) => (
    <div style={Object.assign({width: 430 }, MAIN_SECTION)}>
        <Header>Your new disclosures</Header>
        <div className="x-all-recent-disclosures" style={{height: 800, overflow: "auto"}}>
            { props.disclosures.map(disclosure => <RecentDisclosure key={disclosure.disclosureUri} {...disclosure} />)}
        </div>
    </div>
);
RecentDisclosures.propTypes = {
    disclosures: React.PropTypes.arrayOf(React.PropTypes.object)
};

const mapStateToProps = (state) => ({
    disclosures: getRecentDisclosures(state)
});

export default connect(mapStateToProps)(RecentDisclosures);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/RecentDisclosures.js
 **/